import { Component, Input, OnInit, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TreeNode } from 'primeng/api';
import { Facet } from 'src/app/models/facet-model';
import { FacetSelected } from 'src/app/models/facet-selected-model';
import { FormsService } from 'src/app/services/forms.service';
import { QueryStateService } from 'src/app/services/query-state.service';

@Component({
  selector: 'app-results-facets',
  templateUrl: './results-facets.component.html',
  styleUrls: ['./results-facets.component.css']
})
export class ResultsFacetsComponent implements OnInit, OnChanges {

  @Input() facets?: Facet;
  @Input() facetsVisible: boolean = false;
  @Output() onApplyFacets = new EventEmitter<any>();
  @Output() onToggleFacets = new EventEmitter<any>();

  dateMsg: string = "<br/><br/> NOTE: Large result counts (more than 1000) might not show all dates. <br/><br/> Select a Year or Month to help refine the count to show any missing months or days in the options.";

  selectedAuthors: string[] = [];
  selectedDocumentType: string[] = [];
  selectedDocketNumber: string[] = [];
  selectedDateAdded: string[] = [];
  selectedDateAddedNodes: TreeNode[] = [];
  selectedDateDocketed: string[] = [];
  selectedDateDocketedNodes: TreeNode[] = [];
  selectedDocumentDate: string[] = [];
  selectedDocumentDateNodes: TreeNode[] = [];
  selectedLicenseNumber: string[] = [];
  selectedDocumentReportNumber: string[] = [];
  selectedAuthorAffiliation: string[] = [];
  selectedAddresseeName: string[] = [];
  selectedAddresseeAffiliation: string[] = [];
  selectedIsLegacy: string[] = [];
  selectedIsPackage: string[] = [];

  constructor(private querySvc: QueryStateService, private formSvc: FormsService, private fb: FormBuilder) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes['facets']) {
      let nf = changes['facets'].currentValue as Facet;
      this.facets = changes['facets'].currentValue as Facet;
      // this.facets.DateAdded = nf.DateAdded; 
    }
  }

  updateAuthors() {
    // console.log('Updating AuthorName...');
    this.updateFacetSelection('AuthorName', this.selectedAuthors);
  }

  updateDocumentType() {
    // console.log('Updating DocumentType...');
    this.updateFacetSelection('DocumentType', this.selectedDocumentType);
  }

  updateDocketNumber() {
    // console.log('Updating DocketNumber...');
    this.updateFacetSelection('DocketNumber', this.selectedDocketNumber);
  }

  updateLicenseNumber() {
    this.updateFacetSelection('LicenseNumber', this.selectedLicenseNumber);
  }

  updateDocumentReportNumber() {
    this.updateFacetSelection('DocumentReportNumber', this.selectedDocumentReportNumber);
  }

  updateAuthorAffiliation() {
    this.updateFacetSelection('AuthorAffiliation', this.selectedAuthorAffiliation);
  }

  updateAddresseeAffiliation() {
    this.updateFacetSelection('AddresseeAffiliation', this.selectedAddresseeAffiliation);
  }

  updateAddresseeName() {
    this.updateFacetSelection('AddresseeName', this.selectedAddresseeName);
  }

  updateIsLegacy() {
    this.updateFacetSelection('IsLegacy', this.selectedIsLegacy);
  }

  updateIsPackage() {
    this.updateFacetSelection('IsPackage', this.selectedIsPackage);
  }

  updateFacetSelection(fieldName: string, selectedItems: string[]) {
    let ff: FacetSelected = { field: fieldName, values: selectedItems };
    this.querySvc.updateSelectedFacets(ff);
    this.onApplyFacets.emit(true);
  }

  dateFacetTreeAdd(facetName: string, item: string, collection: string[]) {
    //  console.log('Sr-DateAdded: ' + JSON.stringify(item));
    collection = [];
    collection.push(item);
    this.updateFacetSelection(facetName, collection);
  }

  dateFacetTreeRemove(facetName: string, item: string, collection: string[]) {
    collection.splice(collection.indexOf(item), 1);
    this.updateFacetSelection(facetName, collection);
  }

  updateDateAdded(item: any) {
    this.dateFacetTreeAdd('DateAdded', item, this.selectedDateAdded);
  }

  removedDateAdded(item: any) {
    this.dateFacetTreeRemove('DateAdded', item, this.selectedDateAdded);
  }

  updateDateDocketed(item: any) {
    this.dateFacetTreeAdd('DateDocketed', item, this.selectedDateDocketed);
  }

  removedDateDocketed(item: any) {
    this.dateFacetTreeRemove('DateDocketed', item, this.selectedDateDocketed);
  }

  updateDocumentDate(item: any) {
    this.dateFacetTreeAdd('DocumentDate', item, this.selectedDocumentDate);
  }

  removedDocumentDate(item: any) {
    this.dateFacetTreeRemove('DocumentDate', item, this.selectedDocumentDate);
  }

  toggleFacets() {
    this.facetsVisible = !this.facetsVisible;
    this.onToggleFacets.emit(this.facetsVisible);
  }

  clearFacets() {
    this.querySvc.clearSelectedFacets();
    this.selectedAuthors = [];
    this.selectedDocumentType = [];
    this.selectedDocketNumber = [];
    this.selectedDateAdded = [];
    this.selectedDateAddedNodes = [];
    this.selectedDateDocketed = [];
    this.selectedDateDocketedNodes = [];
    this.selectedDocumentDate = [];
    this.selectedDocumentDateNodes = [];
    this.selectedLicenseNumber = [];
    this.selectedDocumentReportNumber = [];
    this.selectedAuthorAffiliation = [];
    this.selectedAddresseeName = [];
    this.selectedAddresseeAffiliation = [];
    this.selectedIsLegacy = [];
    this.selectedIsPackage = [];

    this.onApplyFacets.emit(false);
  }
}
